import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs';
import { endpoints } from '../../utils/endpoints';
import {
    InviteToTargetIdRequest,
    UpdateInvitationOptions,
} from '../models/api/requests/profileInvitations.request';
import { Invitation } from '../models/api/responses/profileInvitations.response';
import { ProfileInvitationStatusType } from '../models/enums/profile.enum';

@Injectable(
    {
        providedIn: 'root',
    }
)
export class InvitationService {
    private http = inject(HttpClient);


    updateStatus(
        invitationId: string,
        status: ProfileInvitationStatusType,
        options: UpdateInvitationOptions = {}
    ) {
        return this.http.put(
            endpoints.invitations.children.updateStatus(invitationId, status),
            options
        );
    }

    sendInvitations(request: InviteToTargetIdRequest) {
        return this.http.post(endpoints.invitations.endpoint, request);
    }

    getAllProfileInvitations(profileId: string) {
        return this.http
            .get<Invitation[]>(
                endpoints.invitations.children.getAllInvitationsOfPlayer(
                    profileId
                )
            )
            .pipe(shareReplay());
    }
}
